<template>
  <div class="app">
    <v-app id="vapp">
      <!-- 用来播放音频 -->
      <audio id="audioPlayer" src></audio>
      <!-- 标题栏、应用头-->
      <div class="toolbar">
        <iDS-ToolBar></iDS-ToolBar>
        <iDS-SnackBar class="snackbar"></iDS-SnackBar>
      </div>
      <!-- 页面内容显示区域-->
      <div class="content">
        <!-- 页面切换动画, 但是暂未使用-->
        <transition name="router-view-transition" :enter-active-class="animatedIn" :leave-active-class="animatedOut"
          mode="out-in">
          <router-view :style="{ position: absoluteStyle }"></router-view>
        </transition>
      </div>
      <!-- 底部按钮区域-->
      <div class="footbar">
        <!-- 底部页面切换, 默认高度 56px-->
        <iDS-BottomNav v-if="bottomNavVisible"></iDS-BottomNav>
        <!-- 底部功能按钮, 默认高度 36px-->
        <iDS-BottomBtn v-if="bottomBtnVisible"></iDS-BottomBtn>
      </div>
      <v-dialog persistent v-if="sheetUpdatVersion" :value="sheetUpdatVersion" @input="setIsUpdateVersionFalse"
        max-width="200px" max-height="300px">
        <v-card>
          <v-card-title>
            <span>{{ $t('检测到更新') }} {{ appServerVersion }}</span>
          </v-card-title>
          <v-img src="imgs/svg/eds/updateVersion.svg"></v-img>
          <v-card-actions>
            <v-btn flat @click="onUpdateVersion(false)">{{ $t('稍后再说') }}</v-btn>
            <v-btn flat color="primary" @click="onUpdateVersion(true)">{{ $t('立即下载') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-if="getPlatform() != 'browser' && showUpdateProgressBar" :value="updateProgressBarPre"
        max-width="300px" max-height="20px">
        <div style="text-align: center">{{ $t('正在下载更新文件') }}</div>
        <v-progress-linear :value="updateProgressBarPre"></v-progress-linear>
      </v-dialog>
      <iDS-RequestStorage class="requestStorage"></iDS-RequestStorage>
    </v-app>
  </div>
</template>

<script>
import iDSToolBar from './views/iDSToolBar'
import iDSBottomNav from './views/iDSBottomNav'
import iDSBottomBtn from './views/iDSBottomBtn'
import iDSSnackBar from './views/iDSSnackBar'
import iDSRequestStorage from './views/iDSRequestStorage'
import swal from 'sweetalert2'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import * as faceapi from 'face-api.js'
import msgbus from './msgBus'
import funcListConfig from './funcListConfig'
import functions from './functions'
import eventMaps from './eventMaps'
import operations from './operations'
import dateHelper from './util/date'
import dbHelper from './util/db'
import debugHelper from './util/debug'
import devHelper from './util/devHelper'
import tools from './util/tools'
import { setInterval, clearInterval } from 'timers'
import { Toast } from 'mint-ui'

export default {
  name: 'app',
  components: {
    iDSToolBar,
    iDSBottomNav,
    iDSBottomBtn,
    iDSSnackBar,
    iDSRequestStorage,
  },
  data: function () {
    return {
      vm: this,
      animatedIn: '',
      animatedOut: '',
      absoluteStyle: 'inherit',
      chosenUpdateApk: false, // 是否已选择更新apk
    }
  },
  computed: {
    ...mapGetters('app', ['displayName']),
    ...mapGetters('login', {
      '__accountID': 'getAccountID'
    }),
    ...mapGetters('update', { // 由msgbus中转的计算属性无法监听，这里另外生成一份
      '__appDispVersion': 'getAppDispVersion',
      '__appServerVersion': 'getAppServerVersion',
    }),
    bottomNavVisible: function () {
      return this.getBottomNavVisible()
    },
    title: function () {
      return this.getTitle()
    },
    bottomBtnVisible: function () {
      return this.getBottomBtnVisible()
    },
    msgInputVisible: function () {
      return this.getMsgInputVisible()
    },
    marginTop: function () {
      return `calc( 0px + ${this.getScrollTop()}px )`
    },
    // app服务端版本号
    appServerVersion() {
      return msgbus.vm.getAppServerVersion()
    },
    // 是否显示更新提示框
    sheetUpdatVersion() {
      return msgbus.vm.getIsUpdateVersion()
      // return true
    },
    showUpdateProgressBar() {
      return msgbus.vm.getUpdateProgressPre() > 0
      // return true
    },
    updateProgressBarPre() {
      return msgbus.vm.getUpdateProgressPre()
      // return 50
    },
  },

  methods: {
    setIsUpdateVersionFalse() {
      msgbus.vm.setIsUpdateVersion({ value: false })
    },
    // 更新版本
    onUpdateVersion(update) {
      if (update) {
        this.chosenUpdateApk = true
        functions.versionCheckHelper.funcDownloadVersion()
      }
      msgbus.vm.setIsUpdateVersion({ value: false })

      if (!update) {
        this.debounceChcpCheck()
      }
    },

    async loadFaceApi() {
      await faceapi.loadTinyFaceDetectorModel(
        'https://idsapp.hzdatalink.com/tiny_face_detector_model-weights_manifest.json'
      )
    },
    /**
     * 检查并刷新登陆权限
     */
    mCheckAndRefresh() {
      console.log('调试代码 mCheckAndRefresh')
      // 获取Token及Token过期时间
      var expire = dbHelper.get('expire')
      expire = dateHelper.string2Timestamp(expire)
      var now = dateHelper.getLocalTimestamp()
      var tid = dbHelper.get('tid')

      if (now > expire) {
        // 清空localstorage里用户相关的数据，包含清token
        dbHelper.restore()
        // 跳转登录页面
        if (this.$route.name !== 'pwdlogin') {
          this.$router.replace({ name: 'pwdlogin' })
        }
      } else {
        tools.startFuncList(msgbus, this, funcListConfig.common.refreshToken)
      }
    },

    registerEvents() {
      // 取消所有已绑定的事件
      this.$off()

      // 绑定事件
      eventMaps.forEach((eventMap) => {
        this.$on(eventMap.id, eventMap.func)
      })

      msgbus.$on('main', (action) => {
        debugHelper.log(action)
        debugHelper.log(this)
        this.$emit(action.id, this, action.funcList)
      })

      msgbus.vm = this
    },

    /**
     * 设置字体大小, 计算 1rem = ?px
     */
    fontSetter() {
      var ele = document.getElementsByTagName('html')[0],
        size = ((document.body.clientWidth - 320) / 704) * 6 + 14
      ele.style.fontSize = size + 'px'

      //设置底部高度
      var tmp = document.getElementsByClassName('ids-bottom-nav')[0]
      if (tmp != null) {
        msgbus.vm.setContentBottomHeight({ value: tmp.clientHeight + 2 + 'px' })
      }
    },

    mSetParams(funcList) {
      var func = funcList[0]

      switch (func.id) {
        case operations.eCreateBottomsByRoles:
          func.params.roles = this.getUserRoles()
          break
      }
      return funcList
    },
    mGetResult(funcList) {
      var func = funcList[0]
      return funcList
    },

    /**
     * Cordova插件加载成功时执行该方法
     */
    onDeviceReady() {
      // 设置设备平台
      this.setPlatform(window.device.platform)
      debugHelper.log(`platform: ${window.device.platform}`)
      debugHelper.log('设备加载完成')

      // 打开数据库
      functions.sqliteHelper.openDatabase()

      // 违规行为整改
      let interval = setInterval(() => {
        if ((dbHelper.get('privacyGuidelines') || 'true') === 'false' && // 已同意隐私政策权
          (dbHelper.get('isAgreeLicence') || 'false') === 'true') { // 已同意软件许可与服务协议
          clearInterval(interval)
          interval = undefined
          // 违规行为：未经许可读取个人信息 | 获取ANDROID ID
          if (typeof window.device.getUuid === 'function') {
            window.device.getUuid(function (info) {
              debugHelper.log(`uuid: ${window.device.platform.uuid}`)
            })
          }

          // 违规行为：未经许可读取个人信息 | 获取应用列表
          if (
            typeof window.cordova.plugins.notification.badge
              .manualInitialize === 'function'
          ) {
            window.cordova.plugins.notification.badge.manualInitialize()
          }

          // 极光推送隐私合规
          if (typeof window.JPush.setAuth === 'function') {
            window.JPush.setAuth(true)
          }
        }
      }, 1000)

      // 隐藏启动的图案
      navigator.splashscreen.hide()
      this.fontSetter()

      // 屏幕常亮
      if (window.device.platform !== 'browser') {
        window.plugins.insomnia.keepAwake()
      }

      // alert('onDeviceReady')
      // 注册监听事件
      if (msgbus.vm.getPlatform() == 'Android') {
        // alert('device.version' + device.version)
        window.plugins.intent.setNewIntentHandler(
          functions.edsfileview.funcHandleIntent
        )
        window.plugins.intent.getCordovaIntent(
          functions.edsfileview.funcHandleIntent,
          function () { }
        )
      }
      if (
        this.$router.history.current.name != 'licence' &&
        this.$router.history.current.name != 'privacy'
      ) {
        // alert('mCheckAndRefresh')
        // 检查并刷新登陆权限
        this.mCheckAndRefresh()
      }
    },
    onResume() {
      dbHelper.set('launchTimes', '2') //切一次之后，直接设置启动次数为2

      // alert('onResume')
      this.mCheck()
    },
    mCheck() {
      console.log('调试代码 mCheck', this.$route.name)
      if (
        this.$route.name === 'licence' ||
        this.$route.name === 'privacy' ||
        this.$route.name === 'resetpwd'
      ) {
        return
      }

      if (window.device.platform !== 'browser' &&
        (dbHelper.get('privacyGuidelines') || 'true') === 'false' && // 已同意隐私政策权
        (dbHelper.get('isAgreeLicence') || 'false') === 'true') { // 已同意软件许可与服务协议
        window.cordova.plugins.notification.badge.clear()
      }
      var token = dbHelper.get('token')
      var expire = dateHelper.string2Timestamp(dbHelper.get('expire'))
      var now = dateHelper.getLocalTimestamp()

      if (!token || expire == 0 || now > expire) {
        // 清空localstorage里用户相关的数据，包含清token
        dbHelper.restore()
        // 跳转登录页面
        if (this.$route.name !== 'pwdlogin') {
          this.$router.replace({ name: 'pwdlogin' })
        }
      } else {
        if (msgbus.vm.getPlatform() === 'iOS') {
          functions.edsfileview.GetOpenAsFileName()
        } else {
          functions.edsfileview.funcEdsFileOpen()
        }
      }
    },

    toggleFullScreen() {
      if (tools.BrowserType() == 'Chrome' && !tools.isPC()) {
        debugHelper.log('进入全屏模式')
        document.body.webkitRequestFullscreen()
      }
    },
    /**
     * 更新视图高度
     */
    updateViewHeight() {
      setTimeout(() => {
        var tmp = document.getElementById('vapp')

        //设置底部高度
        var bottomTmp = document.getElementsByClassName('ids-bottom-nav')[0]
        if (
          (bottomTmp = document.getElementsByClassName('ids-bottom-nav')[0])
        ) {
          msgbus.vm.setContentBottomHeight({
            value: bottomTmp.clientHeight + 2 + 'px',
          })
        } else if (
          (bottomTmp = document.getElementsByClassName('ids-bottom-btn')[0])
        ) {
          msgbus.vm.setContentBottomHeight({
            value: bottomTmp.clientHeight + 2 + 'px',
          })
        }

        var bottomHeight = '0px'
        if (this.bottomBtnVisible) {
          bottomHeight = '36px'
        } else if (this.bottomNavVisible) {
          bottomHeight = this.getContentBottomHeight()
        }

        this.setContentHeight({
          value:
            `calc(${tmp.style.height} - 48px - ${bottomHeight} ` /*+ iosHeight*/ +
            ')',
        })
      }, 300)
    },

    firstPlayAudio() {
      debugHelper.log('启用音频播放器')
      var audio = document.getElementById('audioPlayer')
      audio.play()
      audio.pause()
      document.removeEventListener('touchstart', this.firstPlayAudio)
    },

    eventBackButton() {
      var that = this
      if (
        this.$router.history.current.name == 'document' &&
        msgbus.vm.getIsMultiSelect()
      ) {
        // 退出多选状态
        msgbus.vm.setIsMultiSelect({ value: false })
        msgbus.vm.setSelectedFiles({ value: [] })
      } else {
        if (
          this.$router.history.current.name == 'pwdlogin' ||
          this.$router.history.current.name == 'sessionlist' ||
          this.$router.history.current.name == 'document' ||
          this.$router.history.current.name == 'work' ||
          this.$router.history.current.name == 'myinfo'
        ) {
          Toast(this.$t('再点击一次退出!'))

          document.removeEventListener(
            'backbutton',
            that.eventBackButton,
            false
          ) //注销返回键
          //3秒后重新注册
          var intervalID = window.setInterval(function () {
            window.clearInterval(intervalID)
            document.addEventListener('backbutton', that.eventBackButton, false) //返回键
          }, 3000)
        } else {
          this.$router.back(-1)
        }
      }
    },

    changeView() {
      msgbus.vm.setTitle(this.displayName)
      msgbus.vm.setBackDisabled(true)
      msgbus.vm.setBackIcon('')
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setMsgInputVisible({ value: false })
    },
    chcpCheck() {
      if (
        this.sheetUpdatVersion || // 检查到Apk更新交互
        this.chosenUpdateApk || // 选择了立即下载Apk
        !this.__appDispVersion || // 还没有应用的显示版本号
        !this.__appServerVersion // 还没有应用服务端版本号
      ) {
        return
      }

      // 热更新检查（应用的大版本小于等于服务端Apk的大版本时更新）
      const appV = this.__appDispVersion.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)/)
      const serV = this.__appServerVersion.match(/^(\d+)\.(\d+)\.(\d+)(?:\.(\d+))?/)
      if (appV && serV) {
        // 例：需要热更新
        // appV[0]=1.2.22.88    appV[1]=1   appV[2]=2   appV[3]=22  appV[4]=88
        // serV[0]=2.0.21.66    serV[1]=2   serV[2]=0   serV[3]=21  serV[4]=66
        let app1 = parseInt(appV[1])
        let app2 = parseInt(appV[2])
        let app3 = parseInt(appV[3])
        let sev1 = parseInt(serV[1])
        let sev2 = parseInt(serV[2])
        let sev3 = parseInt(serV[3])
        // 先比第一项，若app1<sev1,则热更新;若=,则再比第二项;
        // 比第二项，若app1==sev1且app2<sev2,则热更新；若=,则再比第三项;
        // 比第三项，若app1==sev1且app2==sev2且app3<=sev3,则热更新;
        if (app1 < sev1 || (app1 == sev1 && app2 < sev2) || (app1 == sev1 && app2 == sev2 && app3 <= sev3)) {
          window.chcp.fetchUpdate((error, data) => {
            if (devHelper.isDevMode()) {
              alert(`fetchUpdate: ${JSON.stringify({ error, data })}`)
            }
            window.chcp.installUpdate((error) => {
              if (devHelper.isDevMode()) {
                alert(`installUpdate: ${JSON.stringify({ error })}`)
              }
            })
          })
        }
      }
    },
    chcp_updateInstalledCB(eventData) {
      swal.close()
      this.showSwal()
    },
    chcp_nothingToUpdateCB() {
      swal.close()
    },
    chcp_updateLoadFailedCB() {
      swal.close()
    },
    showSwal() {
      swal.fire({
        text: this.$t('已成功为您安装最新版本'),
        title: this.$t('自动更新'),
        type: 'success',
        showConfirmButton: false,
        timer: 1500,
      })
    },
    ...mapGetters('app', [
      'getLanguage',
      'getLocalVersion',
      'getTitle',
      'getBackSpecialRoute',
      'getDeveloper',
      'getBottomNavVisible',
      'getPlatform',
      'getBottomBtnVisible',
      'getHomePageRoute',
      'getScrollTop',
      'getMenuDisabled',
      'getMenuIcon',
      'getMenuItems',
      'getSingleButtonDisabled',
      'getSingleButton',
      'getTitleInfo',
      'getTitleList',
      'getBottomBtn',
      'getBottomBtnLoading',
      'getBottomNavButtons',
      'getMsgInputVisible',
      'getContentHeight',
      'getIsPwd',
      'getContentInnerHeight',
      'getContentBottomHeight',
      'getTTSToken',
      'getTimer',
    ]),
    ...mapActions('app', [
      'setLanguage',
      'setBottomBtnLoading',
      'setBottomNavVisible',
      'setPlatform',
      'setTitle',
      'setTitleAndIcon',
      'setTitleStyle',
      'setBackIcon',
      'setToolbarDisabled',
      'setBackDisabled',
      'setBottomBtnVisible',
      'setBackSpecialRoute',
      'setHomePageRoute',
      'setMenuDisabled',
      'setMenuIcon',
      'setMenuItems',
      'setSingleButtonDisabled',
      'setSingleButton',
      'fetchTTSToken',
      'setTitleVisible',
      'setTitleList',
      'setTimer',
    ]),
    ...mapMutations('app', [
      'setContentHeight',
      'setContentInnerHeight',
      'setScrollTop',
      'setContentBottomHeight',
      'setMsgInputVisible',
      'setBottomBtn',
      'setBottomNavButtons',
      'setBottomActiveBtn',
      'setMessageTips',
      'setTaskTips',
      'setSnackBar',
      'setRequestStorage',
      'setIsPwd',
    ]),
    ...mapGetters('login', [
      'getAccountInfo',
      'getAccountID',
      'getAccountToken',
      'getAccountTenants',
      'getAccountTenantKeys',
      'getTokenExpire',
      'getCurrentTenantID',
      'getCurrentTenantName',
      'getCurrentTenantLogo',
      'getCurrentTenantServiceAPI',
      'getCurrentTenantServiceVersion',
      'isEDS16',
      'getUserOID',
      'getUserName',
      'getUserInfo',
      'getUserRoles',
      'getUserRoleRights',
      'getPhoneNumber',
      'getPassword',
      'getRegcode',
      'getRegcodeWaitingTime',
    ]),
    ...mapActions('login', [
      'fetchAuthToken',
      'refreshAuthToken',
      'fetchUserInfo',
      'updateUserPwd',
    ]),
    ...mapMutations('login', [
      'setLoginSuccess',
      'setCurrentTenant',
      'setPhoneNumber',
      'setPassword',
      'setRegcode',
      'setRegcodeWaitingTime',
    ]),
    ...mapGetters('message', [
      'getSessions',
      'getMessages',
      'getSessionTotalCount',
      'getMessageTotalCount',
      'getMessageUnreadNum',
      'getMessageInfo',
      'getCurrentSession',
    ]),
    ...mapActions('message', [
      'fetchSessions',
      'appendSessions',
      'fetchMessages',
      'appendMessages',
      'fetchMsgForBadge',
    ]),
    ...mapMutations('message', ['setCurrentSession']),
    ...mapGetters('file', ['getFstoken']),
    ...mapActions('file', ['fetchFsToken', 'putFs', 'delFs']),

    ...mapGetters('right', ['judgeHasButtonRight']),
    ...mapActions('right', ['setCurButtonRights']),
    ...mapMutations('location', ['setGPS']),
    ...mapGetters('location', ['getShowTime']),
    ...mapActions('location', ['setShowTime']),
    ...mapGetters('param', [
      'getParamOfNonPumpOrderLimitTime',
      'getParamOfPumpOrderLimitTime',
    ]),
    ...mapActions('param', [
      'fetchParamOfNonPumpOrderLimitTime',
      'fetchParamOfPumpOrderLimitTime',
    ]),
    ...mapGetters('document', [
      'getActiveTabName',
      'getIsMultiSelect',
      'getSelectedFiles',
      'getRecentFileTotalCount',
      'getDownloadFileTotalCount',
      'getRecentFiles',
      'getDownloadFiles',
      'getRecentFileFilter',
      'getDownloadFileFilter',
      'getIsDownloading',
    ]),
    ...mapActions('document', [
      'fetchRecentFilesTotalCount',
      'fetchDownloadFilesTotalCount',
      'fetchRecentFiles',
      'appendRecentFiles',
      'fetchDownloadFiles',
      'appendDownloadFiles',
    ]),
    ...mapMutations('document', [
      'setActiveTabName',
      'setIsMultiSelect',
      'setSelectedFiles',
      'setRecentFilesFilter',
      'setDownloadFilesFilter',
      'setIsDownloading',
    ]),
    ...mapGetters('work', [
      'getWorkType',
      'getFlowTypes',
      'getUserFlows',
      'getUserTasks',
      'getUserTasksStatus',
      'getUserTasksMessage',
      'getFlowInfo',
      'getFlowFiles',
      'getFlowProcess',
      'getUserFlowTotalCount',
      'getUserTaskTotalCount',
      'getUserAwaitingFlowTotalCount',
      'getUserAwaitingTaskTotalCount',
      'getFlowListRecordCount',
      'getTaskListRecordCount',
      'getFlowStateFilterSetInfo',
      'getFlowTypeFilterSetInfo',
      'getTaskStateFilterSetInfo',
      'getTaskFlowTypeFilterSetInfo',
      'getCurrentFlow',
    ]),
    ...mapActions('work', [
      'fetchFlowTypes',
      'fetchUserFlows',
      'appendUserFlows',
      'fetchUserTasks',
      'appendUserTasks',
      'fetchFlowInfo',
      'fetchFlowFiles',
      'fetchFlowProcess',
      'requestFlowSourceFiles',
      'checkPreparedDownloadFile',
      'fetchUserAwaitingFlowsTotalCount',
      'fetchUserAwaitingTasksTotalCount',
      'taskApprove',
      'taskReject',
    ]),
    ...mapMutations('work', [
      'setUserTasks',
      'setFlowListRecordCount',
      'setTaskListRecordCount',
      'setFlowStateFilterSetInfo',
      'setFlowTypeFilterSetInfo',
      'setTaskStateFilterSetInfo',
      'setTaskFlowTypeFilterSetInfo',
      'setCurrentFlow',
    ]),
    ...mapMutations('work', {
      workSwitchTenant: 'switchTenant',
    }),
    ...mapGetters('update', [
      'getAppDispVersion',
      'getIsUpdateVersion',
      'getAppServerVersion',
      'getAppDownloadUrl',
      'getUpdateProgressPre',
    ]),
    ...mapActions('update', ['checkAndroidAppVersion', 'checkIOSAppVersion']),
    ...mapMutations('update', [
      'setAppDispVersion',
      'setIsUpdateVersion',
      'setUpdateProgressPre',
    ]),
  },

  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/')[1]
      const fromDepth = from.path.split('/')[1]
      switch (`${fromDepth} -> ${toDepth}`) {
        case 'sessionlist -> messagelist':
          this.animatedIn = 'list-enter list-enter-active'
          this.animatedOut = 'list-leave .list-leave-active'
          break
        default:
          this.animatedIn = ''
          this.animatedOut = ''
          break
      }
    },
    resize() {
      this.fontSetter()
      this.updateViewHeight()
    },
    __appDispVersion(newVal, oldVal) {
      if (newVal) {
        this.debounceChcpCheck()
      }
    },
    __appServerVersion(newVal, oldVal) {
      if (newVal) {
        this.debounceChcpCheck()
      }
    },
    __accountID(newVal, oldVal) {
      if (newVal) { // 登录后获取应用显示版本号，以便触发热更新检查
        functions.versionCheckHelper.funcGetAppDispVersion()
      }
    }
  },

  created: function () {
    dbHelper.set('launchTimes', '1') //第一次启动设置启动次数为1
    this.registerEvents()

    document.addEventListener('deviceready', this.onDeviceReady, false)
    document.addEventListener('resume', this.onResume, false)
    document.addEventListener(
      'chcp_updateInstalled',
      this.chcp_updateInstalledCB,
      false
    )
    document.addEventListener(
      'chcp_nothingToUpdate',
      this.chcp_nothingToUpdateCB,
      false
    )
    document.addEventListener(
      'chcp_updateLoadFailed',
      this.chcp_updateLoadFailedCB,
      false
    )
    // this.loadFaceApi()
    // dbHelper.set('launchTimes', 'first')

    this.debounceChcpCheck = tools.debounce(() => this.chcpCheck(), 500)
  },

  mounted: function () {
    // 每次旋转，调用这个事件。
    window.addEventListener('orientationchange', this.updateViewHeight, false)
    document.addEventListener('touchstart', this.firstPlayAudio)
    // 事件的初始化
    this.updateViewHeight()
    window.addEventListener('resize', this.fontSetter, false)
    document.addEventListener('backbutton', this.eventBackButton, false) //返回键
  },
  updated: function () { },
  beforeDestroy() { },
}
</script>

<style lang="scss">
html,
body,
.app {
  height: 100%;
}

#vapp {
  height: 100%;

  &>.application--wrap {
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;

    &>.content {
      background: #ffffff;
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}

.toolbar {
  width: 100%;
  z-index: 102;
}

.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: #ffffff;
}

.footbar {
  z-index: 100;
  width: 100%;
  bottom: 0px;
  background: white;
}

.testIn {
  animation-duration: 0.5s;
  /*animation-delay: 0.5s;*/
}

.testOut {
  /*animation-duration: 0.5s;*/
  animation-duration: 0.5s;
}

// /* 解决移动端问题 */
// .application--wrap {
//   min-height: 0px;
//   height: 100%;
// }

audio {
  display: none;
}

/* 去掉谷歌的右边箭头  */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

// 加上以下的内容,ios safari端会出现无法输入的bug
// input[type='number'] {
//   -moz-appearance: textfield;
// }
// * {
//   -webkit-touch-callout: none;
//   -webkit-user-select: none;
//   -khtml-user-select: none;
//   -moz-user-select: none;
//   -ms-user-select: none;
//   user-select: none;
// }
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}

.list-enter,
.list-leave {
  opacity: 0;
  transform: translateX(300px);
}
</style>
